(function () {
    'use strict';

    angular.module('swif.achats')
        .directive('warehouseBreadcrumbSelector', warehouseBreadcrumbSelector);

    /**
     * @descrition
     * This component provide an input select one that works with site content type
     * It is used in the patrimoine referentiel
     *
     * Specific controller for the "parent warehouse" selector widget.
     * The widget allows for a hierarchical selection of warehouse.
     * 
     * It makes use of the swifSelectWithBreadcrumb widget and the inner
     * workings are losely deduced of of SwifWidgetSelectWithBreadcrumb for
     * lack of documentation
     *
     * @ngdoc directive
     * @name swif.achats:warehouseBreadcrubSelector
     * @module swif.ui
     * @restrict E
     *
     * @usage

        <warehouse-breadcrumb-selector
            ng-model="model"
            ng-required="ngRequired"
            breadcrumb-field="breadcrumb_ids"
            parent-field="parent_id"
            icon="fa-map-marker"
            filter="filter.sites">
        </warehouse-breadcrumb-selector>
     *
     */
    function warehouseBreadcrumbSelector(swif, gettextCatalog) {
        'ngInject';
        return {
            restrict: 'E',
            templateUrl: 'partials/achats/inputWarehouseBreadcrumb.html',
            require: 'ngModel',
            scope: {
                breadcrumbField: '@?',
                parentField: '@',
                helpText: '@?',
                filter: '=?',
                ngRequired: '=?',
                noDisplayInput: '=?',
                icon: '@?',
                onChange: '&?'
            },
            link: function (scope, element, attr, ngModel) {
                scope._ = _;
                var initialize = function () {
                    scope.displayInput = false;
                    scope.fields = ['name', 'complete_name'];
                    scope.breadcrumbField = scope.breadcrumbField || 'breadcrumb_names';
                    scope.proxy = {selected: false, items: [], fake: {value: false, filter: {fields: scope.fields}}};
                    updateFilters();
                };

                scope.translate = {
                    'bePrecise': gettextCatalog.getString('Could you be more precise ?'),
                    'exactName': gettextCatalog.getString('the exact name'),
                    'hierarchy': gettextCatalog.getString('on the entire hierarchy')
                };

                ngModel.$render = function () {
                    var vv = ngModel.$viewValue;
                    if (vv) {
                        updateProxyItems(vv)
                        .then(function (data) {
                            console.log('ngModel.$render')
                            setSelected();
                            updateFilters();
                        });
                    }
                };

                var setViewValue = function () {
                    ngModel.$setViewValue(scope.proxy.selected);
                };
                var getFilter = function () {
                    var filter = {};
                    if (scope.filter) {
                        filter = angular.copy(scope.filter);
                    }
                    filter.fields = scope.fields;
                    // Filter by authorized warehouse
                    var user = swif.user.getAuthenticatedUserData();
                    swif.data.addFilter(filter, 'id', 'in', user.warehouse_ids || []);
                    return filter;
                };
                scope.toggleCompleteName = function () {
                    if (scope.fields.length === 1) {
                        scope.fields[1] = 'complete_name';
                        scope.proxy.fake.nameOnly = false;
                    } else {
                        scope.fields.splice(1, 1);
                        scope.proxy.fake.nameOnly = true;
                    }
                };
                scope.deleteSelected = function () {
                    console.log('deleteSelected')
                    scope.proxy.items = [];
                    setSelected();
                    updateFilters();
                    setViewValue();
                };
                scope.selectParent = function () {
                    console.log('selectParent')
                    scope.proxy.items.pop();
                    setSelected();
                    updateFilters();
                    setViewValue();
                };
                var updateFilters = function () {
                    var fakeFilter = getFilter();
                    if (scope.proxy.selected) {
                        swif.data.addFilter(
                            fakeFilter,
                            scope.parentField, '=',
                            scope.proxy.selected[0]
                        );
                    }
                    scope.proxy.fake.filter = fakeFilter;
                    scope.displayInput = false;
                    swif.data.getContentRange('stock_warehouse', scope.proxy.fake.filter)
                    .then(function (count) {
                        scope.displayInput = count > 0;
                    });
                };

                var updateProxyItems = function (lastSite) {
                    return swif.data.get('stock_warehouse', lastSite[0], {fields: [scope.breadcrumbField]})
                    .then(function (data) {
                        var items = [];
                        var ids = data[scope.breadcrumbField];
                        var filter = {fields: ['name']};
                        if (_.isEmpty(ids)) {
                            ids = [];
                        }
                        ids.splice(0, 0, lastSite[0]);
                        swif.data.addFilter(filter, 'id', 'in', ids);
                        return swif.data.searchRead('stock_warehouse', filter).then(function (sites) {
                            var orderedSites = {};
                            _.forEach(sites.records, function (val) {
                                orderedSites[val.id] = [val.id, val.name];
                            });
                            _.forEach(ids, function (id) {
                                var item = {value: orderedSites[id]};
                                items.splice(0, 0, item);
                            });
                            scope.proxy.items = items;
                            return scope.proxy.items;
                        });
                    });
                };

                var setSelected = function () {
                    var last = scope.proxy.items[scope.proxy.items.length - 1];
                    if (last) {
                        scope.proxy.selected = last.value;
                    } else {
                        scope.proxy.selected = false;
                    }
                    scope.proxy.hasValue = scope.proxy.selected ? true: undefined;
                };

                scope.onFakeChanged = function () {
                    var val = scope.proxy.fake.value;
                    if (val) {
                        scope.proxy.fake.value = false;
                        updateProxyItems(val).then(function () {
                            console.log('onFakeChanged')
                            setSelected();
                            updateFilters();
                            setViewValue();
                        });
                        if(scope.onChange) {
                            scope.onChange({ item: val });
                        }
                    }
                };

                // when an item is changed inside the breadcrumb,
                // we just update filters and let selectOne to apply the filter
                // => we only remove the item if the value is cleared
                scope.onItemChanged = function (item, index) {
                    if (!item.value) {
                        scope.proxy.items.splice(index, 1);
                    }
                    console.log('onItemChanged')
                    setSelected();
                    updateFilters();
                    setViewValue();
                };
                scope.$watch('filter', function (newV) {
                    console.log('scope.$watch')
                    updateFilters();
                }, true);
                initialize();
            }
        };
    }
})();
